/** โหลดรายการจาก endpoint หนึ่งเส้นแล้วแสดงเป็นตาราง (อ่านอย่างเดียว) — ใช้ร่วมกันในหน้าจอใหม่ของรอบ D-179…D-184 */

import { useEffect, useState, type ReactNode } from 'react';

import { fetchRecords, type RecordRow } from '../../lib/backend/records';
import { stockFailureText } from '../../lib/inventory/stock';
import { RecordTable, type RecordColumn } from './RecordTable';

export interface RecordPanelProps {
  readonly path: string;
  readonly params?: Readonly<Record<string, string | undefined>>;
  readonly columns: readonly RecordColumn[];
  readonly testId: string;
  readonly apiBaseUrl?: string;
  readonly fetchImpl?: typeof fetch;
  /** เปลี่ยนค่านี้เพื่อบังคับโหลดใหม่ (เช่น หลังสร้างรายการ) */
  readonly reloadToken?: number;
  readonly empty?: string;
  readonly rowActions?: (row: RecordRow) => ReactNode;
}

export function RecordPanel({
  path,
  params = {},
  columns,
  testId,
  apiBaseUrl,
  fetchImpl,
  reloadToken = 0,
  empty,
  rowActions,
}: RecordPanelProps) {
  const [rows, setRows] = useState<readonly RecordRow[]>([]);
  const [error, setError] = useState<string | null>(null);
  const paramKey = JSON.stringify(params);

  useEffect(() => {
    let cancelled = false;
    void (async () => {
      const result = await fetchRecords(path, params, {
        ...(apiBaseUrl === undefined ? {} : { apiBaseUrl }),
        ...(fetchImpl === undefined ? {} : { fetchImpl }),
      });
      if (cancelled) {
        return;
      }
      if (result.status !== 'ready') {
        setRows([]);
        setError(stockFailureText(result));
        return;
      }
      setError(null);
      setRows(result.items);
    })();
    return () => {
      cancelled = true;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [path, paramKey, apiBaseUrl, fetchImpl, reloadToken]);

  return (
    <>
      {error !== null && (
        <p className="cap-notice__note" role="alert" data-testid={`${testId}-error`}>
          {error}
        </p>
      )}
      <RecordTable
        rows={rows}
        columns={columns}
        testId={testId}
        {...(empty === undefined ? {} : { empty })}
        {...(rowActions === undefined ? {} : { rowActions })}
      />
    </>
  );
}
